define(['underscore', 'bootstrap/tooltip'], function (_, Tooltip) {
    'use strict';

    return (config, target) => {
        _.map(target.querySelectorAll('a[title]'), element => new Tooltip(element, config));
    };
});
